const kindType = (kind) => {
  const kinded = {
    0: 'Plano de ação',
    1: 'Evidência',
  }

  return kinded[kind] || kind
}

export default kindType
